import React, { PropTypes } from 'react';
// Components
import Item from './Item';

const propTypes = {
  days: PropTypes.array.isRequired,
};

const Dates = (props) => {
  const items = props.days.map((day) => {
    return <Item key={day} day={day} {...props}>{day}</Item>;
  });

  return (
    <div className="ui top attached tabular menu">
      {items}
    </div>
  );
};

Dates.propTypes = propTypes;

export default Dates;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/dates/Dates.js
 **/